;
window.initPhotoOverlay = function () {
  const photoOverlaySelector = '[data-photo-overlay-photos]'
  const photoOverlayPhotoSelector = '[data-photo-overlay-photo]'

  var photoOverlays = document.querySelectorAll(photoOverlaySelector)
  for (var i = 0; i < photoOverlays.length; ++i) {
    var photoOverlay = photoOverlays[i]
    if (!photoOverlay.getAttribute('lg-uid')) {
      lightGallery(photoOverlay, {
          selector: photoOverlayPhotoSelector
      })
    }
  }
}

$(function () {
  window.initPhotoOverlay()
})
